import type { CalendarDesign } from "#internal"

import { CalendarMonthAreas } from "../CalendarMonthAreas"
import { PictureCover } from "../PictureCover"

/** Eaves, a stitched landscape calendar: the year low on its picture; a picture facing each month, its name over its grid, the months either side small left of it, the contact under. */
export const Eaves: CalendarDesign = {
  cover: PictureCover({ at: 0.3, size: 0.16 }),
  page: (boxes, month) => CalendarMonthAreas(boxes, month, false),
  pages: "spread",
}
